var scrollPosition = require('../functions/scroll-position'),
	slideshowClick = require('./slideshow-click'),
	slideshowAnimations = require('./slideshow-animations'),
	slideshowEvents = require('./slideshow-events'),
	slideshow = function() {
		var $cotoSlideshow = document.querySelectorAll('.coto_slideshow');

		for (let $slideShow of $cotoSlideshow) {
			var $slide = $slideShow.querySelectorAll('.coto_slide'),
				$productThumbnails = document.querySelector('.product-thumbnails'),
				isLoaded = $slideShow.classList.contains('loaded'),
				noTimer = $slideShow.classList.contains('no-timer'),
				addNavigation = $slideShow.classList.contains('coto_slide-controls'),
				addPagination = $slideShow.classList.contains('coto_slide-pagination'),
				addArrows = $slideShow.classList.contains('coto_slide-arrows'),
                arrowsNav = $slideShow.classList.contains('coto_slide-arrows-nav'),
				timer,
				slideTimer = function() {
					if (!noTimer) {
						clearTimeout(timer);
						timer = setTimeout(function() {
							slideshowAnimations($slideShow);
							slideTimer();
						}, 8000);
					}
				},
				slideshowEvent = function() {
					var isActive = $slideShow.classList.contains('active');

					scrollPosition($slideShow, function(reset) { 
						if (reset) {
							clearTimeout(timer);
							$slideShow.classList.remove('active');
						} else {
							if (!isActive) {
								slideTimer();
								$slideShow.classList.add('active');
							}
						}
					});
				};

			if (!isLoaded) {
				$slide[0].classList.add('current-slide');

				if (addNavigation || addPagination || addArrows) {
					var itemLength = $slide.length,
						slideControls = $slideShow.classList.contains('coto_slide-controls');

					// Create Navigation
					if (itemLength > 1) {
						if (addNavigation || addPagination) {
							var createNav = document.createElement('nav');

							createNav.className = 'coto_slideshow-nav';

							if ($slideShow.classList.contains('coto_story-content-slider')) {
								$slideShow.querySelector('.coto_col-xl-4').appendChild(createNav);
							} else {
								$slideShow.appendChild(createNav);
							}

							for (let i = 0; i < itemLength; i++) {
								var createPagination = document.createElement('button');
								createPagination.setAttribute('type', 'button');

								createPagination.className = 'pagination-button';
								if (i == 0) {
									createPagination.className = 'active pagination-button';
								}
								createNav.appendChild(createPagination);
							}
						}

						if (addNavigation || addArrows) {
							if (arrowsNav) {
								var createNav = document.createElement('nav');

								createNav.className = 'coto_slideshow-arrows-nav';

								$slideShow.appendChild(createNav);
							}
							for (let i = 0; i < 2; i++) {
								var createButton = document.createElement('button');

								createButton.setAttribute('type', 'button');

								if (i == 0) {
									createButton.className = 'prev coto_slide-button';
									createButton.setAttribute('aria-label', 'previous-slide-button');
								} else {
									createButton.className = 'next coto_slide-button';
									createButton.setAttribute('aria-label', 'next-slide-button');
								}

								if (arrowsNav) {
									$slideShow.querySelector('.coto_slideshow-arrows-nav').appendChild(createButton);
								} else {
									$slideShow.appendChild(createButton);
								}
							}
						}

						// Slideshow Button Events
						var $slideshowButton = $slideShow.querySelectorAll('.coto_slide-button');

						// Slideshow Button
						for (let $button of $slideshowButton) {
							$button.addEventListener('click', function() {
								var direction = 'right',
									isAnimating = $slideShow.querySelector('.next-slide');

								if (!isAnimating) {
									if (this.classList.contains('prev')) {
										direction = 'left';
									}

									clearTimeout(timer);
									slideshowAnimations($slideShow, null, direction);
									slideTimer();
								}
							});
						}

						$slideShow.addEventListener('click', function(event) {
							var obj = event.target,
								isAnimating = $slideShow.querySelector('.next-slide');

							if (obj.classList.contains('pagination-button') && !isAnimating) {
								event.stopPropagation();

								var isActive = obj.classList.contains('active'),
									index = [...obj.parentElement.children].indexOf(obj);

								if (!isActive) {
									clearTimeout(timer);
									slideshowClick($slideShow, obj);
									slideshowAnimations($slideShow, index);
                                    slideTimer();
                                    
								}
							}
                            
						});

						// Slide show Swipe
						var touchStartX = 0,
							touchEndX = 0;

						$slideShow.addEventListener('touchstart', function(event) {
							touchStartX = event.changedTouches[0].screenX;
						});

						$slideShow.addEventListener('touchend', function(event) {
							var obj = event.target,
								isAnimating = $slideShow.querySelector('.next-slide');

							if (!obj.classList.contains('coto_slideshow-nav') && !obj.classList.contains('pagination-button') && !obj.classList.contains('coto_slide-button') && !isAnimating) {
								var direction = 'right',
									throttle;

								touchEndX = event.changedTouches[0].screenX;
								throttle = touchStartX - touchEndX;

								if (touchEndX > touchStartX) {
									direction = 'left';
									throttle = touchEndX - touchStartX;
								}

								if (throttle > 60) {
									clearTimeout(timer);
									slideshowAnimations($slideShow, null, direction);
									slideTimer();
								}
							}
						});
					}

					// Slideshow mouse enter and leave
					$slideShow.addEventListener('mouseenter', function() {
						clearTimeout(timer);
						$slideShow.classList.remove('active');
					});

					$slideShow.addEventListener('mouseleave', function() {
						slideTimer();
						$slideShow.classList.add('active');
					});
				}

				if ($productThumbnails) {
					var $thumbnails = $productThumbnails.getElementsByTagName('figure'),
						$slideshowNav = document.querySelector('.coto_slideshow-nav'),
						$slideShowNavButton = $slideshowNav.querySelectorAll('.pagination-button');

					for (let $thumbnail of $thumbnails) {
						$thumbnail.addEventListener('click', function() {
							var index = [...this.parentElement.children].indexOf(this),
								$activeThumbnail = $productThumbnails.querySelector('.active');

							if ($activeThumbnail) {
								$activeThumbnail.classList.remove('active');
							}
							
							this.classList.add('active');
							$slideShowNavButton[index].click();
						});
					}
				}

				$slideShow.classList.add('loaded');
				window.addEventListener('scroll', slideshowEvent);
				window.addEventListener('load', slideshowEvent);
			}
		}
	};

module.exports = slideshow;